import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#AddPermissionModal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }),
  /*#__PURE__*/_createTextVNode(" Ajouter une permission ")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, "Nom "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, "Description "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, "Rôle "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, "DATE DE CREATION "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, "Actions")
  ])
], -1)
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_17 = { class: "dropdown" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_26 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddPermissionModal = _resolveComponent("AddPermissionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.checkPermission('AddPermission'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un privilège"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_7
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (permission, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(permission.nom), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(permission.description), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission.rolePermissions, (rolePermission, roleIndex) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: roleIndex,
                          class: "badge text-bg-primary rounded-pill fs-13 me-5"
                        }, [
                          (rolePermission.role)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(rolePermission.role.description), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.format_date(permission.createdAt)), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("ul", _hoisted_19, [
                        (_ctx.checkPermission('EditPermission'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.moddifier(permission))
                              }, [
                                _hoisted_22,
                                _createTextVNode(" Modifier ")
                              ], 8, _hoisted_21)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('DeletePermission'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.suppression(permission.id,_ctx.permissions,'permissions',`le permission ${permission.description}`))
                              }, [
                                _hoisted_25,
                                _createTextVNode(" Supprimer ")
                              ], 8, _hoisted_24)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddPermissionModal, {
      onGetAllPermissions: _ctx.getAllPermissions,
      id: _ctx.idpermission,
      onOpenmodal: _ctx.showModalEdite
    }, null, 8, ["onGetAllPermissions", "id", "onOpenmodal"])
  ], 64))
}